import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../oidc/auth.service";
import { environment } from "../../../environments/environment";


@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private authService: AuthService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        let status = this.authService.isLoggedIn();
        if (!status) {
            this.router.navigate(["/authentication/login"]);
            //location.href = environment.p365Host;
        }
        return status;
    }
}
